import { getBirthDate } from 'lib/birthNumber'
import { differenceInYears, startOfYear } from 'date-fns'

// Calculate priority based on age and risk group
// Based on https://www.fhi.no/sv/vaksine/koronavaksinasjonsprogrammet/hvem-kan-fa-koronavaksine/
// eslint-disable-next-line complexity
export function calculatePriority({
  nationalId,
  isHealthPersonnel = false,
  isRiskGroupA = false,
  isRiskGroupB = false,
}) {
  // Find current age
  // Note: We consider everyone to be born 1. jan, to support FHIs definition of age groups
  const currentAge = differenceInYears(new Date(), startOfYear(new Date(getBirthDate(nationalId))))

  // Helsepersonell
  if (isHealthPersonnel) {
    return 50 // Prio 50 is just for internal use
  }

  // High age (85+)
  if (currentAge > 84) {
    return 2
  }

  // High age (75+)
  if (currentAge > 74) {
    return 3
  }

  // High age (65+)
  if (currentAge > 64) {
    return 4
  }

  // Risk group A
  if (isRiskGroupA) {
    // Sub 18 is a special group and should never get priority 4
    if (currentAge > 17) {
      return 4
    }
  }

  // Risk group B
  if (isRiskGroupB) {
    // Age 55-64
    if (currentAge > 54) {
      return 5
    }

    // Age group 45-54
    if (currentAge > 44) {
      return 6
    }

    // Age group 18-44
    if (currentAge > 17) {
      return 7
    }
  }

  // Just age (55+)
  if (currentAge > 55) {
    return 8
  }

  // Just age (45+)
  if (currentAge > 45) {
    return 9
  }

  // Just age (18-24)
  if (currentAge > 17 && currentAge < 25) {
    return 10
  }

  // Just age (40-44)
  if (currentAge > 39 && currentAge < 45) {
    return 10
  }

  // Just age (25-39)
  if (currentAge > 24 && currentAge < 40) {
    return 11
  }

  // Just age (12-17)
  if (currentAge > 11 && currentAge < 18) {
    return 12
  }

  // Just age (11 and below)
  if (currentAge > 0 && currentAge < 12) {
    return 13
  }

  // Previously all non-prioritised, meaning healty individuals below age 45 got priority 99
  // Now we keep this just as a failsafe
  return 99 // Prio 99 is just for internal use
}

// Decide which priority we're going to use. The calculated one or (if available) the one set by an admin
export function decideNewPriority({ calculatedPriority, originalPriority = null }) {
  // No original priority (meaning they're not on the candidate list)
  if (!originalPriority && originalPriority !== 0) {
    return calculatedPriority
  }

  // Health care workers should never have their priority changed
  if (originalPriority === 50) {
    return 50
  }

  // "Upgrade" priority based on a persons health declaration (ex: 9 -> 4)
  if (calculatedPriority < originalPriority) {
    return calculatedPriority
  }

  // Keep original priority if it's higher than the calculated
  return originalPriority
}
